<template>
  <account-user />
</template>

<script>
import { mapMutations } from 'vuex'

import AccountUser from '@/components/AccountUser'

export default {
  components: {
    AccountUser,
  },

  data() {
    return {
      //
    }
  },

  computed: {
    //
  },

  mounted() {
    this.errorsDataAccessAllSetFalse()
    this.nodeCurrentSet({})
  },

  methods: {
    //
    ...mapMutations([
      'nodeCurrentSet',
      'errorDataUnauthorizedAccessSet',
      'errorsDataAccessAllSetFalse',
    ]),
  },
}
</script>
